const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

// DBS wave reveal animation for every page section.
function initializeButlerWaveReveal(rootEl = document) {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const scope = rootEl === document ? document : rootEl;
  const main = document.getElementById('MainContent');
  if (!main) return;

  const candidates = Array.from(scope.querySelectorAll ? scope.querySelectorAll('#MainContent > .shopify-section, #MainContent > .section, .shopify-section') : []);
  const sections = candidates.filter((section) => {
    if (!main.contains(section)) return false;
    if (section.classList.contains('shopify-section-group-header-group')) return false;
    if (section.classList.contains('shopify-section-group-footer-group')) return false;
    if (section.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group')) return false;
    // Do not animate the booking wrapper because it contains the fixed WhatsApp button.
    // A transformed ancestor changes fixed positioning on mobile browsers.
    if (section.querySelector('[data-floating-whatsapp]')) return false;
    return true;
  });

  if (!sections.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('butler-wave-reveal--visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -14% 0px',
    threshold: 0.12,
  });

  sections.forEach((section, index) => {
    if (section.classList.contains('butler-wave-reveal--initialized')) return;
    section.classList.add('butler-wave-reveal', 'butler-wave-reveal--initialized');
    section.style.setProperty('--butler-wave-order', String(Math.min(index, 5)));

    // Keep the first block visible immediately on page load.
    if (index === 0 || section.getBoundingClientRect().top < window.innerHeight * 0.75) {
      section.classList.add('butler-wave-reveal--visible');
      return;
    }

    observer.observe(section);
  });
}

window.addEventListener('DOMContentLoaded', () => initializeButlerWaveReveal());

if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeButlerWaveReveal(event.target));
  document.addEventListener('shopify:section:reorder', () => initializeButlerWaveReveal(document));
}
